/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      // 按钮元素
      this.button = this.querySelector('.load-more');
      // 产品网格元素
      this.grid = document.querySelector('[data-id=' + id + ']');
      // 动画是否启用
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      // 当前页数
      this.i = 2;
    }
    // 在自定也元素连接的时候调用   根据class类别调用
    connectedCallback() {
      
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    // 当URL中添加页码参数,用于加载更多或调用无限滚动
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      //如果search字符串存在，然后从中构建
      if (search) {
        // Try to replace an existance instance
        //尝试替换一个存在的实例
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        //如果没有被        替换，然后在末尾添加一个新的参数
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    // 用于加载更多类型的分页，他监听更多按钮的点击事件，并在点击时候调用loadProducts方法
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    // 方法用于无限滚动类型分页，它使用IntersectionObserver API监视元素是否进入视口，
    // 当进入视口的时候调用loadProducts方法 渲染到页面
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    // 负责加载加载产品数据，并在加载后调用 renderProducts 方法渲染到页面上
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    // 负责将加载的产品数据渲染到页面上,并支持动画效果
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
    }
  }
  // 最后通过customElements.define()方法将Pagination自定义元素注册到浏览器中，使其可以在文档中使用
  customElements.define('pagination-theme', Pagination);
}